
export class DateHelper {

  static getNextMonth(date: Date): Date {
    const newDate = new Date(date);
    newDate.setMonth(date.getMonth() + 1);
    return newDate;
  }

  static getMonthAfterNext(year: number, month: number): Date {
    const newDate = new Date(year, month - 1, 1);
    newDate.setMonth(newDate.getMonth() + 2);
    return newDate;
  }

  static get today(): Date {
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    return now;
  }

  static isTodayOrFutureDate(date: Date): boolean {
    if (!date) {
      return false;
    }

    const d = new Date(date);
    d.setHours(0, 0, 0, 0);

    return d >= this.today;
  }

  static isSameOrLaterDate(fromDate: Date, toDate: Date): boolean {
    if (!fromDate || !toDate) {
      return false;
    };

    const from = new Date(fromDate);
    const to = new Date(toDate);

    from.setHours(0, 0, 0, 0);
    to.setHours(0, 0, 0, 0);

    return to >= from;
  }

  //NOTE: toLocaleDateString is not reliable!
  static toSwedishDateFormat(date: Date): string {
    if (date == null) {
      return "";
    }

    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "";
    }

    const result =
      `${date.getFullYear()}-${this.zeroPadSingleDigit(date.getMonth() + 1)}-${this.zeroPadSingleDigit(date.getDate())}`;

    return result;
  }

  private static zeroPadSingleDigit(n: number): string {
    return n < 10 ? "0" + n : n.toString();
  }

  static get nowInSwedishDateFormat(): string {
    return this.toSwedishDateFormat(new Date());
  }
}
